import { GridLayer } from 'react-leaflet'
import { observer } from 'mobx-react'
import { inject } from 'mobx-react'

// leaflet google maps provider
require('leaflet.gridlayer.googlemutant')

const TILE_REFRESH_DELAY_MS = 100

// Wrap the leaflet google plugin so it works like
// a react-leaflet component
@inject(allStores => ({ uiStore: allStores.uiStore }))
@observer class GoogleLayer extends GridLayer {
  initLayer = () => {
    this.leafletElement = window.L.gridLayer.googleMutant({ ...this.props, styles: [] })

    if (this.props.uiStore) {
      this.props.uiStore.forceRefreshTiles = () => this.scheduleTileRefresh()
    }
  }

  scheduleTileRefresh () {
    if (this.tileRefreshTimer) return
    this.tileRefreshTimer = setTimeout(() => {
      this.tileRefreshTimer = null
      const map = this.leafletElement && this.leafletElement._map
      if (!map) return
      const isMoving = map._animatingZoom || map._flyToFrame || (map._panAnim && map._panAnim._inProgress)
      if (isMoving) {
        map.once('moveend', this.refreshTiles, this)
      } else {
        this.refreshTiles()
      }
    }, TILE_REFRESH_DELAY_MS)
  }

  refreshTiles () {
    const layer = this.leafletElement
    if (layer && layer._map && typeof layer._update === 'function') {
      this.setMapType(this.props.type)
      layer._update()
    }
  }

  setMapType (type) {
    const mutant = this.leafletElement && this.leafletElement._mutant
    if (mutant && typeof mutant.setMapTypeId === 'function' && type) {
      try {
        mutant.setMapTypeId(type)
      } catch (e) {}
    }
  }

  componentWillMount () {
    super.componentWillMount()
    this.initLayer()
  }

  componentWillUpdate (props) {
    if (props.type !== this.props.type) {
      this.setMapType(props.type)
      this.scheduleTileRefresh()
    }
  }

  componentWillUnmount () {
    clearTimeout(this.tileRefreshTimer)
    this.tileRefreshTimer = null
    const map = this.leafletElement && this.leafletElement._map
    if (map) map.off('moveend', this.refreshTiles, this)
    if (this.props.uiStore && this.props.uiStore.forceRefreshTiles) {
      this.props.uiStore.forceRefreshTiles = () => {}
    }
    if (super.componentWillUnmount) {
      super.componentWillUnmount()
    }
  }
}

export default GoogleLayer
